
export function isSlotFull(slot) {
    return !slot.isAvailable && !!slot.isOpen;
}
export function isSlotMany(slot) {
    return !!slot.isAvailable && !!slot.hasManyBookings;
}
export function isSlotFree(slot) {
    return !!slot.isAvailable && !slot.hasManyBookings;
}
//export function isSlotClosed(slot) {
//    return !!slot.isAvailable && !slot.hasManyBookings;
//}
